import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface CandidateApplication {
    id: string
    appliedAt: string
    nom: string
    prenom: string
    email: string
    fichePosteId: string
    fichePosteTitle: string
    cvPdf?: string | null
    presentation?: string | null
    candidatEval?: any
    status: string
    questionnaireRepondu?: any
    reponsesQuestionnaire?: any
    fullName?: string
}

export const useCandidateStore = defineStore('candidate', () => {
    const applications = ref<CandidateApplication[]>([])
    const currentApplication = ref<CandidateApplication | null>(null)

    function setApplications(list: CandidateApplication[]) {
        applications.value = list
    }

    function setCurrentApplication(app: CandidateApplication) {
        currentApplication.value = app
    }

    return {
        applications,
        currentApplication,
        setApplications,
        setCurrentApplication
    }
})
